import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import SweetScroll from 'sweet-scroll';
import { forEach } from 'lodash';

import { bindActionCreators } from 'redux';
import {Link} from 'react-router';
import Helmet from 'react-helmet';
import Spinner from '../../components/svg/spinner';
import { profilesRoute } from '../../routes/index';
import css from './profiles.scss';
import Image from '../../components/image/image';
import placeholderImage from './profile-placeholder.png';
import Tooltip from '../../components/tooltip/tooltip';
import translate from '../../utils/translate';
import metaDesc from '../../utils/meta';

import connect from '../../utils/connect';

import { fetchProfiles } from '../../actions/profiles';

//import css from './editorial.scss';

class Profiles extends Component {

	constructor(props) {
		super();

		this.scrollHandler = this.scrollHandler.bind(this);
		this.mounted = true;

		this.state = {
			searched: false,
			isSticky: false,
			stickAtPos: 0,
			stickyHeight: 0,
			headerHeight: 0,
		};

		this.query = '';
		this.offset = '';
		this.limit = '';
		this.order = '';
		this.orderBy = '';
		this.profiles = [];
		this.already = [];
	}

	componentWillMount() {
		//console.log('editorial will mount');
		this.fetchProfiles = bindActionCreators(fetchProfiles, this.props.dispatch);

		this.fetchProfiles();

		if (this.props.browser) {
			this.props.browser.scroll.register(this.scrollHandler);
		}
	}

	componentWillUnmount() {
		this.mounted = false;
		if (this.props.browser) {
			this.props.browser.scroll.deregister(this.scrollHandler);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.browser.window.width !== nextProps.browser.window.width) {
			this.updateDimensions();
		}
	}

	componentDidMount() {
			this.updateDimensions();
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.browser.window.width !== this.props.browser.window.width ||
			nextProps.profiles.next !== this.props.profiles.next ||
			nextProps.profiles.profiles.length !== this.props.profiles.profiles.length ||
			nextProps.profiles.profiles !== this.props.profiles.profiles ||
			nextState !== this.state
		);

		// update on init
		// if ((!this.props.items.length && nextProps.items.length)) {
		// 	return true;
		// }
	}

	componentWillUpdate() {
		this.state.searched = false;
	}

	render() {
		let profiles = this.props.profiles.profiles;
		let spinnerClass = 'profile-list__table__spinner';
		let startNum = 1;
		let total = profiles.length;
		let used = false;

		let _this = this;

		if (profiles.length) {
			if (!this.already.length) {
				forEach(profiles, function(single, i) {
					_this.profiles.push(single);
				});
				this.already.push(profiles[0].id);
			} else {
				forEach(this.already, function(already) {
					if (already == profiles[0].id) {
						used = true;
					}
				});

				if (!used) {
					forEach(profiles, function(single, i) {
						_this.profiles.push(single);
					});

					this.already.push(profiles[0].id);
				}
			}
		}

		if (!this.profiles.length || profiles.length && profiles[0].id !== this.profiles[0].id) {

		}

		if (this.state.searched) {
			spinnerClass = 'profile-list__table__spinner profile-list__table__spinner--active';
		}

		let offset = 0;

		if (this.props.profiles.next) {
			let parameters = this.props.profiles.next;
			parameters = parameters.split('/');
			parameters = parameters[parameters.length - 1];

			parameters = parameters.split('&');

			offset = parameters[0].split('=')[1];

			startNum = offset - profiles.length + 1;

			total = offset;

		};

		if (!this.props.profiles.next && this.props.profiles.prev) {
			let parameters = this.props.profiles.prev;
			parameters = parameters.split('/');
			parameters = parameters[parameters.length - 1];

			parameters = parameters.split('&');

			offset = parameters[0].split('=')[1];

			startNum = parseInt(offset) + 37;

			total = parseInt(offset) + 36 + profiles.length;
		}

		this.inputTimeout = false;

		//console.log(this.props.profiles);

		if (this.props.profiles.meta && this.props.profiles.meta.description !== this.metaDesc) {
			metaDesc(this.props.profiles.meta.description);
			this.metaDesc = this.props.profiles.meta.description;
		}

		const stickyStyle = {};
		const placeholderStyle = {};

		if (this.state.isSticky) {
			placeholderStyle.height = this.state.stickyHeight;

			stickyStyle.position = 'fixed';
			stickyStyle.top = this.state.headerHeight;
			stickyStyle.height = this.state.stickyHeight;
		}

		return (
			<div>
			{(!!profiles.length || profiles.error) && (
				<article className='profile-list span14'>
					<Helmet title={this.props.profiles.meta.title} />
					<div className='profile-list__sticky-placeholder' style={placeholderStyle}></div>
					<div className='profile-list__sticky' ref='stickyElement' style={stickyStyle}>
						<div className='profile-list__top span14'>
							<h1 className='profile-list__top__title'>Profiles</h1>
							<span className='profile-list__top__number'> ({this.props.profiles.totalProfiles})</span>
						</div>
						<input className='profile-list__search span12 pixel-pattern hide-mobile' onChange={(event)=>this.onInput(event)} type='text' placeholder={translate('contextual/profilesSearch')}/>
						<div className='profile-list__right span2 hide-mobile'>
							<h3 className='profile-list__right__title'>showing</h3>
							{!profiles.error && (
							<h2 className='profile-list__right__number'>{startNum + ' — ' + total}</h2>
							) || (
							<h2 className='profile-list__right__number'>None</h2>
							)}
							<h2 className='profile-list__right__total'>{'of ' + this.props.profiles.total}</h2>

							<nav className='profile-list__right__nav'>
								{this.props.profiles.prev && (
								<a href='#head' onClick={(event) => this.profilesNav(event, this.props.profiles.prev)} className='profile-list__right__nav__prev pixel-pattern'><span className='profile-list__right__nav__arrow'></span></a>
								) || (
								<span className='profile-list__right__nav__prev pixel-pattern'><span className='profile-list__right__nav__arrow profile-list__right__nav__arrow--inactive'></span></span>
								)}
								{this.props.profiles.next && (
								<a href='#head' onClick={(event) => this.profilesNav(event, this.props.profiles.next)} className='profile-list__right__nav__next pixel-pattern'><span className='profile-list__right__nav__arrow'></span></a>
								) || (
								<span className='profile-list__right__nav__next pixel-pattern'><span className='profile-list__right__nav__arrow profile-list__right__nav__arrow--inactive'></span></span>
								)}
							</nav>
						</div>
					</div>
					<table sortable={true} className='profile-list__table span12 span14-mobile' ref='tableHead' id='head'>
						<thead>
							<tr>
								<th className='profile-list__table__head__title hide-tablet hide-mobile'></th>
								<th className='profile-list__table__head__title profile-list__table__head__title--left'>Name</th>
								<th data-sort='total' onClick={(event) => this.sortClick(event)} className='profile-list__table__head__title profile-list__table__head__title--total profile-list__table__head__title--sort '>
									<span className='hide-mobile'>Total</span>
									<span className='hide-tablet hide-desktop'>Awards</span>
								</th>
								<th data-sort='FOTD' onClick={(event) => this.sortClick(event)} className='profile-list__table__head__title hide-mobile'>
									<span ref='FOTD'>FOTD</span>
									<Tooltip attachTo={() => this.refs.FOTD}>
										<header>Description:</header>
										<h2>{translate('awards/fotd/title')}</h2>
										{translate('awards/fotd/text')}
									</Tooltip>
								</th>
								<th data-sort='TCEA' onClick={(event) => this.sortClick(event)} className='profile-list__table__head__title hide-mobile'>
									<span ref='TCEA'>TCEA</span>
									<Tooltip attachTo={() => this.refs.TCEA}>
										<header>Description:</header>
										<h2>{translate('awards/tcea/title')}</h2>
										{translate('awards/tcea/text')}
									</Tooltip>
								</th>
								<th data-sort='FOTM' onClick={(event) => this.sortClick(event)} className='profile-list__table__head__title hide-mobile'>
									<span ref='FOTM'>FOTM</span>
									<Tooltip attachTo={() => this.refs.FOTM}>
										<header>Description:</header>
										<h2>{translate('awards/fotm/title')}</h2>
										{translate('awards/fotm/text')}
									</Tooltip>
								</th>
								<th data-sort='FOTY' onClick={(event) => this.sortClick(event)} className='profile-list__table__head__title hide-mobile'>
									<span ref='FOTY'>FOTY</span>
									<Tooltip attachTo={() => this.refs.FOTY}>
										<header>Description:</header>
										<h2>{translate('awards/foty/title')}</h2>
										{translate('awards/foty/text')}
									</Tooltip>
								</th>
								<th data-sort='TCEAY' onClick={(event) => this.sortClick(event)} className='profile-list__table__head__title hide-mobile'>
									<span ref='TCEAY'>TCEAY</span>
									<Tooltip attachTo={() => this.refs.TCEAY}>
										<header>Description:</header>
										<h2>{translate('awards/tceay/title')}</h2>
										{translate('awards/tceay/text')}
									</Tooltip>
								</th>
								<th data-sort='PCA' onClick={(event) => this.sortClick(event)} className='profile-list__table__head__title hide-mobile'>
									<span ref='PCA'>PCA</span>
									<Tooltip attachTo={() => this.refs.PCA}>
										<header>Description:</header>
										<h2>{translate('awards/pca/title')}</h2>
										{translate('awards/pca/text')}
									</Tooltip>
								</th>
								<th data-sort='MOTD' onClick={(event) => this.sortClick(event)} className='profile-list__table__head__title hide-mobile profile-list__table__head__title--no-border'>
									<span ref='MOTD'>MOTD</span>
									<Tooltip attachTo={() => this.refs.MOTD}>
										<header>Description:</header>
										<h2>{translate('awards/motd/title')}</h2>
										{translate('awards/motd/text')}
									</Tooltip>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr ref='profileSpinner' className={spinnerClass}>
								<td><Spinner className='profile-list__table__spinner__spinner' size='80px'></Spinner></td>
							</tr>
							{this.props.browser.window.width < 720 && (
								this.profiles.map((profile, i) => this.renderProfile(profile, i))
							) || profiles.length && (
								profiles.map((profile, i) => this.renderProfile(profile, i))
							) || profiles.error && (
								<tr className='profile-list__profile'>
									<td className='profile-list__profile__cell profile-list__profile__picture span1 hide-tablet hide-mobile'></td>
									<td className='profile-list__profile__cell profile-list__profile__name span4 span10-mobile'>
										{profiles.error.title}
										<span className='profile-list__profile__name profile-list__profile__name__weak'>{profiles.error.message}</span>
									</td>
									<td className='profile-list__profile__cell'></td>
									<td className='profile-list__profile__cell hide-mobile'></td>
									<td className='profile-list__profile__cell hide-mobile'></td>
									<td className='profile-list__profile__cell hide-mobile'></td>
									<td className='profile-list__profile__cell hide-mobile'></td>
									<td className='profile-list__profile__cell hide-mobile'></td>
									<td className='profile-list__profile__cell hide-mobile'></td>
									<td className='profile-list__profile__cell hide-mobile profile-list__profile__cell--no-border profile-list__profile__cell--grey'></td>
								</tr>
							)}
						</tbody>
					</table>
					{this.props.browser.window.width < 720 && this.props.profiles.next && (
						<a href='#head' onClick={(event) => this.profilesNav(event, this.props.profiles.next)} className='profile-list__right__nav__next pixel-pattern'><span className='profile-list__right__nav__arrow'></span></a>
					)}
				</article>
				) || (
				<Spinner className='case-single__spinner' size='80px'></Spinner>
				)
			}
			</div>
		);
	}

	hasClass(element, cls) {
		return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
	}

	sortClick(e) {

		let target = e.target;

		if (!this.hasClass(target, 'profile-list__table__head__title')) {
			target = target.parentNode;
		}

		//console.log(target);

		this.orderBy = target.getAttribute('data-sort');

		if (this.hasClass(target, 'profile-list__table__head__title--sort')) {
			target.classList.toggle('profile-list__table__head__title--sort--asc');
			if (this.order == '') {
				this.order = 'ASC';
			} else {
				this.order = '';
			}
		} else {
			if (document.querySelector('.profile-list__table__head__title--sort')) {
				document.querySelector('.profile-list__table__head__title--sort').classList.remove('profile-list__table__head__title--sort');
			}

			if (document.querySelector('.profile-list__table__head__title--sort--asc')) {
				document.querySelector('.profile-list__table__head__title--sort--asc').classList.remove('profile-list__table__head__title--sort--asc');
			}

			target.classList.add('profile-list__table__head__title--sort');
		}

		this.setState({
			searched: true,
		});

		this.fetchProfiles(0, 36, this.query, this.order, this.orderBy);
	}

	renderProfile(profile, i) {
		let uid = 'profile-' + i;
		let url = profilesRoute(profile.slug);

		let offices = '';

		if (profile.offices.length) {
			for (var i = 0; i < profile.offices.length; i++) {
				if (i < profile.offices.length - 1) {
					offices += profile.offices[i].name + ', ';
				} else {
					offices += profile.offices[i].name;
				}
			}
		} else if (profile.legacyOffice && profile.legacyOffice !== '') {
			offices = profile.legacyOffice;
		}

		return (
			<tr key={uid} className='profile-list__profile'>

				<td className='profile-list__profile__cell profile-list__profile__picture span1 hide-tablet hide-mobile'>
					{profile.logo && profile.logo.normal && (
						<Link to={url}><img {...profile.logo.normal} alt={profile.name} /></Link>
					)}
				</td>

				<td className='profile-list__profile__cell profile-list__profile__name span4 span10-mobile'>
					<Link to={url}>
						{profile.name}
						<span className='profile-list__profile__name profile-list__profile__name__weak'>{offices}</span>
					</Link>
				</td>
				<td className='profile-list__profile__cell'>{profile.stats.total}</td>
				<td className='profile-list__profile__cell hide-mobile'>{profile.stats.FOTD}</td>
				<td className='profile-list__profile__cell hide-mobile'>{profile.stats.TCEA}</td>
				<td className='profile-list__profile__cell hide-mobile'>{profile.stats.FOTM}</td>
				<td className='profile-list__profile__cell hide-mobile'>{profile.stats.FOTY}</td>
				<td className='profile-list__profile__cell hide-mobile'>{profile.stats.TCEAY}</td>
				<td className='profile-list__profile__cell hide-mobile'>{profile.stats.PCA}</td>
				<td className='profile-list__profile__cell hide-mobile profile-list__profile__cell--no-border profile-list__profile__cell--grey'>{profile.stats.MOTD}</td>
			</tr>
		);
	}

	profilesNav(e, href = null) {
		e.preventDefault();
		let parameters = href;
		parameters = parameters.split('/');
		parameters = parameters[parameters.length - 1];

		parameters = parameters.split('&');

		let offset = parameters[0].split('=')[1];

		let limit = parameters[1].split('=')[1];

		let query = parameters[2].split('=')[1];

		this.setState({
			searched: true,
		});

		this.offset = offset;
		this.limit = limit;
		this.query = query;

		if (this.props.browser.window.width > 719) {
			let element = ReactDOM.findDOMNode(this.refs.tableHead);
			if (element && typeof element.getAttribute === 'function') {
				// console.log(element.offsetTop);
				const scroller = new SweetScroll({ offset: -element.offsetTop, duration: 500 });
				scroller.to('#' + element.getAttribute('id'));
			}
		}

		this.fetchProfiles(offset, limit, query, this.order, this.orderBy);
	}

	onInput(e) {
		let string = e.target.value;

		let state = this.state.searched;
		let _this = this;

		clearTimeout(this.inputTimeout);

		if (document.querySelector('.profile-list__table__head__title--sort')) {
			document.querySelector('.profile-list__table__head__title--sort').classList.remove('profile-list__table__head__title--sort');
		}

		if (document.querySelector('.profile-list__table__head__title--sort--asc')) {
			document.querySelector('.profile-list__table__head__title--sort--asc').classList.remove('profile-list__table__head__title--sort--asc');
		}

		document.querySelector('.profile-list__table__head__title--total').classList.add('profile-list__table__head__title--sort');

		this.query = string;

		this.inputTimeout = setTimeout(function() {
			_this.fetchProfiles(0, 36, string, '', '');
			_this.setState({
				searched: true,
			});
		}, 400);
	}

	updateDimensions() {
		const headerHeight = document.querySelector('.header-main').offsetHeight;
		const mainOffsetTop = this.refs.stickyElement ? this.refs.stickyElement.offsetTop : 0;
		const distanceToMenu = (mainOffsetTop - headerHeight) ? (mainOffsetTop - headerHeight) : 1000;

		const stickyHeight = (this.refs.stickyElement) ? this.refs.stickyElement.offsetHeight : 0;

		if (distanceToMenu === 1000) {
			setTimeout(() => {
				this.updateDimensions();
			}, 200);
		}

		this.mounted && this.setState({
			...this.state,
			stickAtPos: distanceToMenu,
			stickyHeight: stickyHeight,
			headerHeight: headerHeight,
		});
	}

	scrollHandler(e) {
		if (e.scrollY === this.prevSrollY) {
			return false; // noop
		} else {
			this.prevSrollY = e.scrollY;
		}

		const isMobile = (this.props.browser.window.width <= 719);
		const isSticky = (e.scrollY >= this.state.stickAtPos && !isMobile);

		if (this.state.stickyHeight <= 0 || this.state.stickAtPos <= 0) {
			return this.updateDimensions();
		}

		// stop setting state if not necessary
		if (this.state.isSticky === isSticky) {
			return false;  // noop
		}

		this.setState({
			...this.state,
			isSticky,
		});
	}
}

export default connect(Profiles);



/** WEBPACK FOOTER **
 ** ./frontend/containers/profiles/profiles.js
 **/